// ── Parent Dashboard ✦ shared palette ──────────────────────────
//
// Single source of truth for the parent-facing visual system.
// Calmer than the Crew side — softer gradients, more whitespace.
// Tuned to feel closer to Apple Health / Monzo / school portal
// than to a social app. Constitutional rules in:
//   /app/memory/PARENT_DASHBOARD_PRD.md
//   /app/memory/PARENT_DASHBOARD_CONSTITUTIONAL_CHECKLIST.md
import { ShieldCheck, Sparkle, Heart, Crown } from '@phosphor-icons/react';

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BG = '#0A0E1F';
export const BG_SOFT = '#10162B';
export const PANEL = 'rgba(255,255,255,0.035)';
export const PANEL_BORDER = 'rgba(255,255,255,0.08)';
export const TEXT = '#EEF1FA';
export const TEXT_MUTED = '#9AA0BD';
export const TEXT_SOFT = '#C5C9DE';
export const BLUE = '#6DA8FF';
export const VIOLET = '#9A8DFF';
export const ROSE = '#FFA7C7';
export const GOLD = '#FFD58A';
export const SAGE = '#86D4B5';
export const FONT_STACK = "'Inter', 'Space Grotesk', system-ui, sans-serif";

export const TIER_COLOUR = { rising: BLUE, trusted: VIOLET, favourite: ROSE, leader: GOLD };
export const TIER_ICON = { rising: Sparkle, trusted: ShieldCheck, favourite: Heart, leader: Crown };
